import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: ${props => props.theme.radius.md};
  padding: ${p => p.theme.app.padding.horizontal};
  justify-content: space-between;
`;

export const InfoCard = styled.div`
  display: flex;
  width: fit-content;
`;

export const Img = styled.div`
  width: ${props => props.theme.avatar.size.md}px;
  height: ${props => props.theme.avatar.size.md}px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 50%;
`;

export const WrapperText = styled.div`
  width: 100%;
  height: 64px;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;
